<template>
  <div>
    <md-card>
      <md-card-header>
        <span class="md-title">
          {{ L(showAccountBalance ? 'accountBalance' : 'promotionCredit') }}
          <span
            v-if="!showAccountBalance"
            style="color: red; font-size: 14px; margin-left: 10px"
          >
            * Google 정보 제공 중단으로 프로모션 크레딧 정보 제공을 중단합니다.
          </span>
        </span>
        <span style="float: right">
          <md-button
            class="md-dense"
            @click.native="showDialog = true"
            style="border: 1px #b1b1b1 solid"
            >{{ L('more') }}...</md-button
          >
        </span>
      </md-card-header>
      <md-card-content style="position: relative">
        <md-table
          v-model="topList"
          md-thin
          md-stripe
          md-fixed-header
          md-height="85px"
          style="padding-top: 0px"
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell :md-label="L('name')">{{ item.name }}</md-table-cell>
            <md-table-cell
              :md-label="L('originalAmount')"
              md-numeric
              style="width: 100px"
              v-if="!showAccountBalance"
              >{{
                (item.original_amount / 1000000)
                  | round2
                  | currency(item.currency)
              }}</md-table-cell
            >
            <md-table-cell
              :md-label="L('remainAmount')"
              md-numeric
              style="width: 100px"
              v-if="!showAccountBalance"
              >{{
                (item.remain_amount / 1000000)
                  | round2
                  | currency(item.currency)
              }}</md-table-cell
            >
            <md-table-cell
              :md-label="L('balance')"
              md-numeric
              style="width: 300px"
              v-if="showAccountBalance"
              >{{
                item.remain_amount | round2 | currency(item.currency)
              }}</md-table-cell
            >
          </md-table-row>
        </md-table>
      </md-card-content>
    </md-card>

    <!-- All Promotion Creadits dialog -->
    <md-dialog :md-active.sync="showDialog" class="md-dialog-md">
      <md-dialog-title>
        {{ L(showAccountBalance ? 'accountBalance' : 'allPromotionCredits') }}
        <span
          v-if="!showAccountBalance"
          style="color: red; margin-left: 20px; font-size: 14px"
        >
          * Google 정보 제공 중단으로 프로모션 크레딧 정보 제공을 중단합니다.
        </span>
      </md-dialog-title>

      <md-dialog-content>
        <md-table
          v-model="fullList"
          md-thin
          md-stripe
          class="md-table-cell-padding-small"
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            v-if="showAccountBalance"
          >
            <md-table-cell :md-label="L('name')" style="width: 270px">{{
              item.name
            }}</md-table-cell>
            <md-table-cell
              :md-label="L('balance')"
              md-numeric
              style="width: 300px"
              >{{
                item.remain_amount | round2 | currency(item.currency)
              }}</md-table-cell
            >
          </md-table-row>

          <md-table-row slot="md-table-row" slot-scope="{ item }" v-else>
            <md-table-cell :md-label="L('name')" style="width: 270px">{{
              item.name
            }}</md-table-cell>
            <md-table-cell
              :md-label="L('originalAmount')"
              md-numeric
              style="width: 130px"
              >{{
                (item.original_amount / 1000000)
                  | round2
                  | currency(item.currency)
              }}</md-table-cell
            >
            <md-table-cell
              :md-label="L('remainAmount')"
              md-numeric
              style="width: 130px"
              >{{
                (item.remain_amount / 1000000)
                  | round2
                  | currency(item.currency)
              }}</md-table-cell
            >
            <md-table-cell
              v-if="$config.platform.id === 'gcp'"
              :md-label="L('startDate')"
              style="width: 120px"
              >{{ item.start_time | formatDate }}
            </md-table-cell>
            <md-table-cell :md-label="L('expiredAt')" style="width: 150px"
              >{{ item.expired_at | formatDate }}
              {{
                isCreditExpired(item) ? L('expiredCheck') : ''
              }}</md-table-cell
            >
          </md-table-row>
        </md-table>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false">{{
          L('close')
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
function isCreditExpired(credit) {
  return (
    credit.expired_at &&
    new Date(credit.expired_at).getTime() < new Date().getTime()
  )
}

export default {
  props: {
    data: Array,
  },

  data: () => ({
    showDialog: false,
  }),

  computed: {
    fullList() {
      return this.data || []
    },

    topList() {
      return this.fullList.filter((item) => !isCreditExpired(item)).slice(0, 3)
    },

    showAccountBalance() {
      return this.$config.feature.accountBalance
    },
  },

  methods: {
    isCreditExpired(credit) {
      return isCreditExpired(credit)
    },
  },
}
</script>

<style lang="scss" scoped>
.md-card {
  display: flex;
  flex-direction: column;
}

.md-card-content {
  flex: 100;
}

.md-dialog-md ::v-deep .md-dialog-container {
  min-width: 800px;
}
</style>
